import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Autocomplete, formatMessage } from '@stssocialst-stp/fe-core';
import { fetchTicketPriorities } from '../actions';

class TicketPriorityPicker extends Component {
  componentDidMount() {
    if (!this.props.priorities.length && !this.props.fetching) {
      this.props.fetchTicketPriorities();
    }
  }

  render() {
    const {
      intl,
      onChange,
      readOnly,
      required,
      withLabel = true,
      withPlaceholder,
      value,
      label,
      filterOptions,
      filterSelectedOptions,
      placeholder,
      multiple,
      priorities,
      fetching,
      error,
    } = this.props;

    return (
      <Autocomplete
        multiple={multiple}
        required={required}
        placeholder={placeholder ?? formatMessage(intl, 'ticket', 'TicketPriorityPicker.placeholder')}
        label={label ?? formatMessage(intl, 'ticket', 'TicketPriorityPicker.label')}
        error={error}
        withLabel={withLabel}
        withPlaceholder={withPlaceholder}
        readOnly={readOnly}
        options={priorities}
        isLoading={fetching}
        value={value}
        getOptionLabel={(option) => option?.nome ?? `${option}`}
        onChange={(option) => onChange(option, option?.nome ?? null)}
        filterOptions={filterOptions}
        filterSelectedOptions={filterSelectedOptions}
        onInputChange={this.props.onInputChange || (() => { })}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  priorities: state.grievanceSocialProtection.ticketPriorities ?? [],
  fetching: state.grievanceSocialProtection.fetchingTicketPriorities,
  error: state.grievanceSocialProtection.errorTicketPriorities,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchTicketPriorities }, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(TicketPriorityPicker));
